<template>
	<v-container>
		<v-row class="d-flex align-center justify-center">
			<v-col
				cols="12"
				md="6"
			>
				<v-breadcrumbs
					class="ml-0 pa-0"
					:items="folderSelected"
				>
					<template v-slot:divider>
						<v-icon>mdi-chevron-right</v-icon>
					</template>
					<template v-slot:item="{ item }">
						<v-breadcrumbs-item
							@click="openFolder(item)"
							style="font-size: 1.5rem; color: #f15a24; cursor: pointer"
						>
							{{ item.text }}
						</v-breadcrumbs-item>
					</template>
				</v-breadcrumbs>
			</v-col>
			<v-col
				class="d-flex align-center justify-center justify-md-end"
				cols="12"
				md="6"
			>
				<!-- <v-text-field v-model="searchArquivos" clearable color="#6e6e6e" class="mt-0 pt-0" placeholder="Buscar Arquivos"
          v-on:keyup.enter="reloadArquivos()">
          <template v-slot:append-outer>
            <button class="btn btn-primary ">Buscar</button>
          </template>
        </v-text-field> -->
				<!-- <v-btn class="mr-3" v-if="false" color="#F15A24" @click="showDialogFolder = true" text><v-icon>mdi-magnify</v-icon>
          Buscar</v-btn> -->
		  <!-- :disabled="user.plano === `plano-free`" -->

				<v-btn
					class="mr-3"
					:small="intBreakPoint < 2"
					color="#F15A24"
					@click="showDialogFolder = true"
					outlined
					><v-icon>mdi-folder-plus</v-icon> Nova Pasta</v-btn
				>
				<!-- :disabled="user.plano === `plano-free`" -->

				<v-btn
					color="#F15A24"
					:small="intBreakPoint < 2"
					@click="showDialog = true"
					class="white--text"
					><v-icon>mdi-upload</v-icon> Novo Documento</v-btn
				>
			</v-col>
		</v-row>
		<!-- 
    <v-row>
      <v-col>
        <label class="tag mr-5">
          <input type="checkbox" class="tag-checkbox mr-1" />
          <span class="tag-container">
            <span class="tag-content">
              <span>PDF</span>
              <span class="tag-icon"></span>
            </span>
          </span>
        </label>
        <label class="tag">
          <input type="checkbox" class="tag-checkbox mr-1" />
          <span class="tag-container">
            <span class="tag-content">
              <span>Word</span>
              <span class="tag-icon"></span>
            </span>
          </span>
        </label>
      </v-col>
    </v-row> -->
		<!-- <v-row class="mb-0 mt-0">
      <v-col cols="12" class="pb-0">
        <h3 class="my-orange gt-bold d-flex align-center mb-0">
          {{
            filteredArquivos.length > 0 || folders.length > 0
            ? filteredArquivos.length +
            " Arquivo" +
            (filteredArquivos.length > 1 ? "s" : "")
            : "Nenhum arquivo"
          }}
          {{ searchArquivos !== null ? " com: " + searchArquivos : "" }}
        </h3>
      </v-col>
    </v-row> -->
		<v-row
			v-if="loadingArquivos"
			align="center"
		>
			<v-progress-circular
				indeterminate
				class="my-orange mx-auto"
			></v-progress-circular>
		</v-row>
		<v-row
			class=""
			style="background-color: #efefef"
		>
			<v-col
				v-for="a in folders"
				:key="a.id"
				cols="6"
				md="3"
				lg="3"
			>
				<v-hover v-slot="{ hover }">
					<v-card
						class="documentos-card"
						@click="openFolder(a)"
						style="cursor: pointer; position: relative"
						:elevation="hover ? 1 : 0"
					>
					<v-chip
							outlined
							label
							v-if="a.grupo"
							small
							@click.stop="$router.push(`/painel/grupo/${a.grupo.id}`)"
							style="
								/* position: relative; */
								/* top: 8px; */
								/* left: 8px; */
								color: #f15a24 !important;
								border: 1px solid #f15a24;
								background-color: white;
								margin: 5px;
							"
						>
							<v-icon
								small
								class="mr-1"
								>mdi-account-group</v-icon
							>
							{{ a.grupo.nome_grupo }}
						</v-chip>
						<v-card-text style="padding-top: 0px !important;" class="text-center documentos-card__text">
							<v-icon x-large> mdi-folder </v-icon>
							<p class="mb-0 documentos-card__title">{{ a.titulo }}</p>
						</v-card-text>

						<div
							v-show="hover"
							class="fileActions"
						>
							<v-menu
								left
								bottom
								:close-on-click="true"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										icon
									>
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item @click="deleteFolder(a.id)">
										<v-btn
											small
											text
											:disabled="loadingDelete"
										>
											<v-icon color="#F15A24">mdi-delete-outline</v-icon>
											Excluir Pasta
										</v-btn>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>

						
					</v-card>
				</v-hover>
			</v-col>

			<v-col
				v-for="a in filteredArquivos"
				:key="a.id"
				cols="6"
				md="3"
				lg="3"
			>
				<v-hover v-slot="{ hover }">
					<v-card class="documentos-card" :elevation="hover ? `1` : `0`">
						<v-chip
							outlined
							label
							v-if="a.grupo"
							small
							@click.stop="$router.push(`/painel/grupo/${a.grupo.id}`)"
							style="
								/* position: absolute; */
								/* top: 8px; */
								/* left: 8px; */
								color: #f15a24;
								margin: 5px;
								border: 1px solid #f15a24;
								background-color: white;
							"
						>
							<v-icon
								small
								class="mr-1"
								>mdi-account-group</v-icon
							>
							{{ a.grupo.nome_grupo }}
						</v-chip>
						<v-card-text style="padding-top: 0px !important;" class="text-center documentos-card__text">
							<v-icon x-large>
								{{
									a.tipo.indexOf(`word`) > -1
										? `mdi-file-word`
										: a.tipo === `application/pdf`
										? `mdi-file-pdf-box`
										: `mdi-file`
								}}
							</v-icon>
							<p
								class="mb-0 documentos-card__title"
								style="cursor: pointer"
								@click="
									downloadFile(a.documento.id, a.documento.filename_download)
								"
							>
								{{ a.titulo }}
							</p>
							<div
								v-show="hover"
								class="fileActions"
							>
								<v-menu
									left
									bottom
									:close-on-click="true"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											v-bind="attrs"
											v-on="on"
											icon
										>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</template>
									<v-list>
										<v-list-item
											@click="
												downloadFile(
													a.documento.id,
													a.documento.filename_download
												)
											"
										>
											<v-btn
												small
												text
											>
												<v-icon color="#F15A24">mdi-download</v-icon>
												Download
											</v-btn> </v-list-item
										><v-list-item
											@click="deleteDocument(a.id)"
											:disabled="loadingDelete"
										>
											<v-btn
												small
												text
											>
												<v-icon color="#F15A24">mdi-delete-outline</v-icon>
												Excluir arquivo
											</v-btn>
										</v-list-item>
									</v-list>
								</v-menu>
							</div>
						</v-card-text>

						
					</v-card>
				</v-hover>
				<!-- <div class="blockArquivo  d-flex flex-column pt-5 pb-2 px-1 align-center justify-center">
          <v-img width="80px" height="80px" contain :src="requireImg('documento.png')" class="mb-0" />

          <p style="width:100%;  border-top:1px solid #dfdbd6;" class="mt-5 mb-0 gt-bold">
            {{ a.titulo }} <small>({{ a.documento ? a.documento.filesize : "" | filesize }})</small> <br />
            <small class="font-weight-light">Criado em {{ a.date_created | brdate }}</small>
          </p>
          <div class="d-flex" style="gap: 1rem">
            <button @click="downloadFile(a.documento.id, a.documento.filename_download)"
              class="my-orange btn btn-tertiary d-flex justify-end align-center "
              style="width:200px; width: 100%; padding-right: 0px;">
              <v-img max-width="30px" class="mr-2" src="../assets/icoDownload.png" />
              Baixar
            </button>

            <button @click="deleteDocument(a.id)" class="my-orange btn btn-tertiary d-flex justify-end align-center "
              style="width:200px; width: 100%; padding-right: 0px;" :disabled="loadingDelete">
              <v-icon color="red">mdi-delete-outline</v-icon>
              Excluir
            </button>
          </div>
        </div> -->
			</v-col>
		</v-row>
		<v-dialog
			width="500px"
			v-model="showDialog"
		>
			<v-card>
				<v-card-title>Adicionar um novo documento</v-card-title>
				<v-card-text>
					<h3>Arquivo</h3>
					<v-file-input
						color="#F15A24"
						v-model="newFile.arquivo"
						label="Selecione o arquivo"
					></v-file-input>
				</v-card-text>
				<v-card-actions class="text-center">
					<v-btn
						color="#F15A24"
						:loading="loadingNewFile"
						dark
						@click="uploadFile"
						>Adicionar Arquivo</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			width="500px"
			v-model="showDialogFolder"
		>
			<v-card>
				<v-card-title>Adicionar uma nova pasta</v-card-title>
				<v-card-text>
					<h3>Nome</h3>
					<v-text-field
						color="#F15A24"
						v-model="newFolder.title"
					></v-text-field>
				</v-card-text>
				<v-card-actions class="d-flex justify-start flex-row-reverse">
					<v-btn
						color="#F15A24"
						:loading="loadingNewFolder"
						dark
						@click="postFolder"
						>Criar Pasta</v-btn
					>
					<v-btn
						color="#F15A24"
						class="mr-3"
						dark
						text
						@click="showDialogFolder = false"
						>Cancelar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- Componente de Avaliação CSAT -->
		<CSATRating 
			page-name="Documentos"
			:pergunta-id="11"
			:delay-seconds="10"
			:auto-show="true"
			@rating-submitted="handleRatingSubmitted"
		/>
	</v-container>
</template>
<style scoped>
.theme--light.v-chip {
    color: #f15a24 !important;
}
	.documentos-card {
		height: 180px;
		display: flex;
		flex-direction: column;
		position: relative;
	}
	.documentos-card .v-card__text {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.documentos-card__title {
		width: 100%;
		height: 2.5em;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word;
	}
	.fileActions {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-end;
		padding: 0 15px;
	}
</style>
<script>
	import CSATRating from '@/components/CSATRating.vue';
	
	export default {
		name: 'Documentos',
		components: {
			CSATRating
		},
		data() {
			return {
				selected: 0,
				newFile: {},
				loadingDelete: false,
				items: [],
				showDialog: false,
				arquivos: [],
				loadingArquivos: false,
				loadingNewFile: false,
				searchArquivos: null,
				order: 'DESC',
				page: 1,
				perPage: 5,
				totalPalavras: 0,
				totalPalavrasFiltrado: 0,
				buscou: false,
				showDialogFolder: false,
				newFolder: {},
				loadingNewFolder: false,
				loadingFolders: false,
				folders: [],
				folderSelected: [{ text: 'Início', id: 'root' }],
			};
		},
		created() {
			this.reloadFolders();
			this.reloadDocumentos();
			// let idPalavra = this.$route.params.idPalavra;
			// if (idPalavra) {
			//    this.searchGlossario = this.$route.params.strPalavra
			// }
			// this.reloadGlossario();

			// this.$http({url:"items/glossario?fields=*,palavra_pai.*"}).then((data) => { this.items = data.data.data; this.loadingGlossario= false},(err) => { window.console.log(err)})
		},
		methods: {
			openFolder(folder) {
				if (folder.id === 'root') {
					this.folderSelected = [{ text: 'Ínicio', id: 'root' }];
				} else {
					this.folderSelected.push({ text: folder.titulo, id: folder.id });
				}
				this.reloadFolders();
				this.reloadDocumentos();
			},
			requireImg(img) {
				return require('../assets/' + img);
			},
			slug(id) {
				var slug = this.sanitizeTitle(id);
				return slug;
			},

			deleteDocument(idDocumento) {
				this.loadingDelete = true;
				this.$http
					.patch(`/items/documentos/${idDocumento}`, { status: 'archived' })
					.then((res) => {
						if (res.status === 200) {
							this.loadingDelete = false;

							window.console.log(`documento deletado`);
							this.reloadDocumentos();
						}
					});
			},

			deleteFolder(idFolder) {
				this.loadingDelete = true;
				this.$http
					.patch(`/items/pastas/${idFolder}`, { status: 'archived' })
					.then((res) => {
						if (res.status === 200) {
							this.loadingDelete = false;
							this.reloadFolders();
						}
					});
			},
			sanitizeTitle(title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');

				return slug;
			},
			uploadFile() {
				this.loadingNewFile = true;
				let file = this.newFile.arquivo;
				const formData = new FormData();
				formData.append('image', file);
				this.$http
					.post('/files', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then((response) => {
						// let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`
						this.postDocument(response.data.data);
					})
					.catch((err) => {
						this.loadingNewFile = false;

						window.console.log(err);
					});
			},
			postFolder() {
				this.loadingNewFolder = true;
				this.$http
					.post('/items/pastas', {
						titulo: this.newFolder.title,
						status: 'published',
						pasta:
							this.folderSelected.length > 1
								? this.folderSelected.slice(-1)[0].id
								: undefined,
					})
					.then(() => {
						this.loadingNewFolder = false;
						this.newFolder.title = '';
						this.showDialogFolder = false;
						this.reloadFolders();
					});
			},
			postDocument(asset) {
				this.$http
					.post('/items/documentos', {
						id_user: this.$store.state.user.id,
						documento: asset.id,
						titulo: asset.title,
						status: 'published',
						tipo: asset.type,
						pasta:
							this.folderSelected.length > 1
								? this.folderSelected.slice(-1)[0].id
								: undefined,
					})
					.then(() => {
						this.newFile = {};
						this.loadingNewFile = false;

						this.showDialog = false;
						this.reloadDocumentos();
					});
			},
			reloadFolders() {
				this.loadingFolders = true;
				this.folders = [];
				let filterFolder =
					this.folderSelected.length > 1
						? `&filter[pasta][_eq]=${this.folderSelected.slice(-1)[0].id}`
						: `&filter[pasta][_null]=true`;
				this.$http({
					//&deep[documento][_aggregate][sum]=filesize
					url:
						'items/pastas?fields=*,documento.*,grupo.*&filter[user_created][_eq]=' +
						this.$store.state.user.id +
						'&filter[status][_eq]=published' +
						filterFolder,
				}).then(
					(res) => {
						this.folders = res.data.data;
						this.loadingFolders = false;
					},
					(err) => {
						window.console.log(err);
					}
				);
			},
			reloadDocumentos() {
				this.loadingArquivos = true;
				this.arquivos = [];
				let filterFolder =
					this.folderSelected.length > 1
						? `&filter[pasta][_eq]=${this.folderSelected.slice(-1)[0].id}`
						: `&filter[pasta][_null]=true`;

				this.$http({
					//&deep[documento][_aggregate][sum]=filesize
					url:
						'items/documentos?fields=*,documento.*,grupo.*&filter[id_user][_eq]=' +
						this.$store.state.user.id +
						'&filter[status][_eq]=published' +
						filterFolder,
				}).then(
					(res) => {
						this.arquivos = res.data.data;
						this.arquivos.map((el) => {
							this.sizeFiles += el.documento.filesize;
						});
						this.loadingArquivos = false;
					},
					(err) => {
						window.console.log(err);
					}
				);
			},
			downloadFile(idFile, strFileName) {
				this.$http({
					url: 'assets/' + idFile + '?download',
					responseType: 'blob',
				}).then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', strFileName);
					document.body.appendChild(link);
					link.click();
				});
			},
			handleRatingSubmitted(data) {
				window.console.log('Avaliação enviada:', data);
				// Você pode adicionar lógica adicional aqui se necessário
			},
		},
		computed: {
			user() {
				return this.$store.state.user;
			},
			sizeFilesPercent() {
				return (this.sizeFiles * 100) / 10485760;
			},
			qtdePage() {
				return Math.ceil(this.totalPalavrasFiltrado / this.perPage);
			},
			filteredArquivos() {
				if (this.searchArquivos != null && this.searchArquivos != '') {
					return this.arquivos.filter((item) => {
						return item.titulo.indexOf(this.searchArquivos) > -1;
					});
				} else {
					return this.arquivos;
				}
			},
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
						return 0;
					case 'sm':
						return 1;
					case 'md':
						return 2;
					case 'lg':
						return 3;
					case 'xl':
						return 4;
					default:
						return 0;
				}
			},
		},
		watch: {
			page(oldValue, newValue) {
				if (oldValue != newValue) {
					this.reloadGlossario();
				}
			},
			searchGlossario(newValue) {
				if (newValue === null) {
					this.buscou = false;
					this.reloadGlossario();
				}
			},
		},
	};
</script>
